var map = {
	"./bloodFat.vue": "./src/views/patient/bloodFat.vue",
	"./bloodGlucose.vue": "./src/views/patient/bloodGlucose.vue",
	"./bloodOxygen.vue": "./src/views/patient/bloodOxygen.vue",
	"./bloodPressure.vue": "./src/views/patient/bloodPressure.vue",
	"./contraction.vue": "./src/views/patient/contraction.vue",
	"./heart.vue": "./src/views/patient/heart.vue",
	"./heartRate.vue": "./src/views/patient/heartRate.vue",
	"./hospital.vue": "./src/views/patient/hospital.vue",
	"./jaundice.vue": "./src/views/patient/jaundice.vue",
	"./move.vue": "./src/views/patient/move.vue",
	"./my.vue": "./src/views/patient/my.vue",
	"./sleep.vue": "./src/views/patient/sleep.vue",
	"./step.vue": "./src/views/patient/step.vue",
	"./temperature.vue": "./src/views/patient/temperature.vue",
	"./uricAcid.vue": "./src/views/patient/uricAcid.vue"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/views/patient sync \\.vue$";